import CashierJackpot from './view';
import { actions, reducer } from './redux';
export { actions, reducer };
export default CashierJackpot;
